/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest model module.
 * @module model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest
 * @version 1.0
 */
class AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest {
    /**
     * Constructs a new <code>AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest</code>.
     * @alias module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest
     * @param beginIpAddr {String} 
     * @param endIpAddr {String} 
     * @param description {String} 
     */
    constructor(beginIpAddr, endIpAddr, description) { 
        
        AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.initialize(this, beginIpAddr, endIpAddr, description);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginIpAddr, endIpAddr, description) { 
        obj['beginIpAddr'] = beginIpAddr;
        obj['endIpAddr'] = endIpAddr;
        obj['description'] = description;
    }

    /**
     * Constructs a <code>AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest} obj Optional instance to populate.
     * @return {module:model/AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest} The populated <code>AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest();

            if (data.hasOwnProperty('beginIpAddr')) {
                obj['beginIpAddr'] = ApiClient.convertToType(data['beginIpAddr'], 'String');
            }
            if (data.hasOwnProperty('endIpAddr')) {
                obj['endIpAddr'] = ApiClient.convertToType(data['endIpAddr'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['beginIpAddr'] && !(typeof data['beginIpAddr'] === 'string' || data['beginIpAddr'] instanceof String)) {
            throw new Error("Expected the field `beginIpAddr` to be a primitive type in the JSON string but got " + data['beginIpAddr']);
        }
        // ensure the json data is a string
        if (data['endIpAddr'] && !(typeof data['endIpAddr'] === 'string' || data['endIpAddr'] instanceof String)) {
            throw new Error("Expected the field `endIpAddr` to be a primitive type in the JSON string but got " + data['endIpAddr']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }

        return true;
    }


}

AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.RequiredProperties = ["beginIpAddr", "endIpAddr", "description"];

/**
 * @member {String} beginIpAddr
 */
AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.prototype['beginIpAddr'] = undefined;

/**
 * @member {String} endIpAddr
 */
AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.prototype['endIpAddr'] = undefined;

/**
 * @member {String} description
 */
AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest.prototype['description'] = undefined;






export default AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest;

